import React from "react";

function BatteryIndicator({ percentage = 0 }) {
  let color = "#169757";
  const activeBars = Math.ceil(percentage / 20);

  if (percentage < 25) {
    color = "#C84630";
    // activeBars = 1;
  } else if (percentage < 60) {
    color = "#F18725";
    // activeBars = 3;
  }

  return (
    <div className="absolute right-3 bottom-2.5 flex flex-col items-end gap-1.5">
      <span
        className="px-1.5 py-1 rounded-md text-[10px] leading-none font-aileron font-semibold text-white  mr-[2px]"
        style={{
          backgroundColor: color,
        }}
      >
        {percentage}%
      </span>

      <div className="relative">
        <div className="w-5 h-[3px] bg-[#DFDFDF] rounded-t-sm mx-auto" />

        {/* battery body */}
        <div className="w-[37px] h-[63px] bg-[#DFDFDF] rounded-[4px] p-0.5 flex flex-col justify-end gap-[3px]">
          {[...Array(5)].map((_, index) => (
            <div
              className="h-2.5 rounded-sm"
              style={{
                backgroundColor:
                  index >= 5 - activeBars ? color : "transparent",
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default BatteryIndicator;
